import { gql } from '@apollo/client';

// Contract queries (backed by documents with type CTA). studyId/organizationId
// are pushed server-side so an SSI page fetches only its own contracts — not the
// global CTA set.
export const GET_CONTRACTS_QUERY = gql`
  query GetContracts($studyId: UUID, $organizationId: UUID, $limit: Int = 100, $offset: Int = 0) {
    documents(studyId: $studyId, organizationId: $organizationId, limit: $limit, offset: $offset, documentType: CTA) {
      edges {
        id
        documentType
        s3Bucket
        s3Key
        originalFilename
        organizationId
        organizationName
        studyId
        studyName
        studyProtocolId
        studyPrimaryAlias
        uploadedBy
        isParsed
        parsedAt
        parsedData
        createdAt
      }
      totalCount
    }
  }
`;

export const GET_CONTRACT_QUERY = gql`
  query GetContract($id: UUID!) {
    document(id: $id) {
      id
      documentType
      s3Bucket
      s3Key
      originalFilename
      mimeType
      fileSizeBytes
      organizationId
      organizationName
      studyId
      studyName
      studyProtocolId
      studyPrimaryAlias
      uploadedBy
      documentDate
      isParsed
      parsedAt
      parsedData
      createdAt
      dismissedAt
    }
  }
`;

export const DOCUMENT_DOWNLOAD_URL_QUERY = gql`
  query DocumentDownloadUrl($id: UUID!, $expiresIn: Int = 3600) {
    documentDownloadUrl(id: $id, expiresIn: $expiresIn) {
      success
      message
      url
    }
  }
`;
